import { useQuery } from "@tanstack/react-query";
import { getSearchAkun, getSearchArea, getSearchKelompok, getSearchUsers, } from "../../services/manajemen/aplikasi.service";
// --- Akun ---
export const useGetSearchAkun = (searchParams) => {
    return useQuery({
        queryKey: ["akun", searchParams],
        queryFn: () => getSearchAkun(searchParams),
        staleTime: 5 * 60 * 1000, // 5 menit
        gcTime: 10 * 60 * 1000, // 10 menit
    });
};
// --- Area ---
export const useGetSearchAreas = (searchParams) => {
    return useQuery({
        queryKey: ["areas", searchParams],
        queryFn: () => getSearchArea(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        placeholderData: (previousData) => previousData,
    });
};
// --- Kelompok ---
export const useGetSearchKelompok = (searchParams) => {
    return useQuery({
        queryKey: ["master", "kelompok", searchParams],
        queryFn: () => getSearchKelompok(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
// --- User ---
export const useGetSearchUsers = (searchParams) => {
    return useQuery({
        queryKey: ["users", searchParams],
        queryFn: () => getSearchUsers(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
import { getUserById, updateUser } from "../../services/manajemen/aplikasi.service";
import { useMutation, useQueryClient } from "@tanstack/react-query";
export const useGetUserById = (idUser) => {
    return useQuery({
        queryKey: ["user", idUser],
        queryFn: () => getUserById(idUser),
        enabled: Boolean(idUser),
    });
};
export const useUpdateUser = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ idUser, payload }) => updateUser(idUser, payload),
        onSuccess: (response, variables) => {
            queryClient.invalidateQueries({ queryKey: ["user", variables.idUser] });
            queryClient.invalidateQueries({ queryKey: ["users"] });
        },
    });
};
